import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  return (
    <section className="section shadow-sm lazyloaded" id="overview">
      <div className="over1">
        <h1
          className="d-block section-heading head-color text-capitalize"
          style={{ marginBottom: "1.25rem" }}
        >
          {project} - Project Overview
        </h1>
        <p>
          L&T Wagle Estate is a prestigious residential development in Thane,
          designed to offer a perfect blend of modern living and seamless
          connectivity. Spanning 5 acres, this newly launched project is set to
          redefine luxury with spacious layouts, premium amenities, and a
          vibrant community environment. With a prime location in Wagle Estate,
          residents will enjoy effortless access to major business hubs, top
          schools, shopping malls, and entertainment zones.
          <br /> Built by L&T Realty, a trusted name in real estate, this
          development ensures high-quality construction, contemporary
          architecture, and thoughtfully planned open spaces. Whether you're a
          homebuyer looking for comfort or an investor seeking high appreciation
          potential, L&T Wagle Estate Thane is an opportunity you don't want to
          miss.
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          Highlights of {project}
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>
                  Situated in Thane's most demanding residential & commercial
                  hub
                </span>
              </li>
              <li>
                <span>
                  Modern Architectural Design with world-class infrastructure
                </span>
              </li>
              <li>
                <span>
                  Seamless Connectivity to Eastern Express Highway & Metro
                </span>
              </li>
              <li>
                <span>
                  Tallest Tower in Thane - 4 Iconic Towers, G+69 Storeys{" "}
                </span>
              </li>
              <li>
                <span>1,00,000 sq.ft Podium Amenities </span>
              </li>
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>Thoughtfully designed layouts for modern families</span>
              </li>
              <li>
                <span>
                  All Standard Amenities - Clubhouse, swimming pool, gym & more
                </span>
              </li>
              <li>
                <span>Lush Green Open Spaces for a peaceful lifestyle</span>
              </li>
              <li>
                <span>59th Floor Open Sky Amenities </span>
              </li>
              <li>
                <span>First-of-its-kind Royal Elevation in Thane </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
